import React from 'react';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { GetJobPositionDto } from '../../../common/spdCore/autogenerated/spdApiClient';

interface JobPositionSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  refresh?: boolean;
  onRowClick: (key: string) => Promise<void> | void | undefined;
}

export const jobPositionForGrid = (jobPosition: GetJobPositionDto) => {
  return {
    key: jobPosition.id,
    values: {
      'jobPosition.name': jobPosition.name || '',
      'jobPosition.harmfulFactorsCount': String(
        jobPosition.harmfulFactorsIds?.length ?? 0,
      ),
    },
  };
};

export const JobPositionSearch: React.FC<JobPositionSearchProps> = props => {
  const columns = [
    { header: 'Nazwa stanowiska', property: 'jobPosition.name' },
    {
      header: 'Liczba czynników szkodliwych',
      property: 'jobPosition.harmfulFactorsCount',
    },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      initialOrderColumn="jobPosition.name"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage="Brak stanowisk predefiniowanych w systemie"
      enableMultiSelect={false}
      refresh={props.refresh}
      onRowClick={props.onRowClick}
    />
  );
};
